import { createFileRoute } from '@tanstack/react-router'
import { AdminCycleManagementPage } from '@/components/auditor-center/AdminCycleManagementPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/audits/$auditCycleId',
)({
  staticData: { pageHeader: { title: 'Audits', pad: false } },
  component: AdminCycleManagementPage,
})
